import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { useBranding } from '../contexts/BrandingContext';
import { getSidebarSections } from './sidebarNavigation';

const Sidebar = () => {
  const { user, logout, isCoach, isParent } = useAuth();
  const colors = useTheme();
  const { brandTitle, brandLogo } = useBranding();
  const sections = getSidebarSections({ role: user?.role, isCoach, isParent });

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="hidden lg:flex lg:flex-shrink-0 fixed inset-y-0 left-0 z-40">
      <div className="flex flex-col w-64">
        <div className="flex flex-col h-full bg-gray-800">
          {/* Logo */}
          <div
            className="flex items-center h-16 flex-shrink-0 px-4"
            style={{ backgroundColor: colors.primary }}
          >
            {brandLogo && (
              <img
                src={brandLogo}
                alt={`${brandTitle} logo`}
                className="h-8 w-auto max-w-[90px] object-contain mr-2"
              />
            )}
            <h1 className="text-xl font-bold text-white truncate" title={brandTitle}>{brandTitle}</h1>
          </div>

          {/* Navigation */}
          <div className="flex-1 flex flex-col overflow-y-auto">
            <nav className="flex-1 px-2 py-4 space-y-1">
              {sections.map((section, sectionIndex) => (
                <React.Fragment key={section.key}>
                  {sectionIndex > 0 && <div className="border-t border-gray-700 my-2"></div>}
                  {section.items.map((item) => (
                    <NavLink
                      key={item.name}
                      to={item.href}
                      className={({ isActive }) =>
                        `group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors ${
                          isActive
                            ? 'text-white'
                            : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                        }`
                      }
                      style={({ isActive }) =>
                        isActive ? { backgroundColor: colors.primary } : {}
                      }
                    >
                      <item.icon
                        className="mr-3 flex-shrink-0 h-6 w-6"
                        aria-hidden="true"
                      />
                      {item.name}
                    </NavLink>
                  ))}
                </React.Fragment>
              ))}
            </nav>
          </div>

          {/* User Profile */}
          <div className="flex-shrink-0 flex bg-gray-700 p-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div
                  className="h-8 w-8 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: colors.primary }}
                >
                  <span className="text-white font-medium text-sm">
                    {user?.name?.charAt(0) || 'U'}
                  </span>
                </div>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-white">{user?.name || 'User'}</p>
                <p className="text-xs text-gray-300 capitalize">{user?.role || 'Member'}</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="ml-auto flex-shrink-0 bg-gray-600 p-1 rounded-md text-gray-400 hover:text-white hover:bg-gray-500 transition-colors"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
